import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Base64func } from "../../../components/Base64Func/Base64func";
import TitleWrapper from "../../../components/TitleWrap/TitleWrap";
import {
  NoBoxResult,
  TOActiveBox,
  TOBoxWrapper,
} from "./TOCOBoxProcess.styled";
import { FiChevronRight } from "react-icons/fi";
import { MdCheckCircle } from "react-icons/md";
import { getCheckerTOBoxesThunk } from "../../../redux/TOThunks/Action";
import { Divider, message } from "antd";
import TMLoader from "../../../components/Loader/Loader";
import { DropboxOutlined } from "@ant-design/icons";
import PrintInvoice from "../../../components/Transfer Order/ToChecker/PrintInvoice";
import { AiOutlineScan } from "react-icons/ai";
import BarcodeScanner from "../../../components/BarcodeScanner/BarcodeScanner";
export class TOCOBoxProcess extends Component {
  state = {
    currTOID: null,
    serviceLoading: false,
    showScannerScreen: false,
    boxData: [],
  };
  componentDidMount = () => {
    this.setState(
      {
        currTOID: Base64func(this.props.match?.params?.TOID, "decode") ?? null,
      },
      () => {
        this.boxApiCall();
      }
    );
  };

  updateBoxId = (value) => {
    this.setState({ showScannerScreen: false });
  };

  boxApiCall = () => {
    this.setState(
      {
        serviceLoading: true,
      },
      () => {
        let data = {
          toNumber: this.state.currTOID,
          access_token: this.props.access_token,
          history: this.props.history,
        };

        this.props.getCheckerTOBoxesThunk(data).then(() => {
          this.setState({
            serviceLoading: false,
          });
          if (this.props.TOReducer?.TOCheckerBoxesErr) {
            message.error(this.props.TOReducer?.TOCheckerBoxesErr);
            this.setState({
              boxData: [],
            });
          } else {
            this.setState({
              boxData: this.props.TOReducer?.TOCheckerBoxesData,
            });
          }
        });
      }
    );
  };

  activeBoxSection = (isActive, boxNumber, p) => (
    <TOActiveBox
      key={p}
      active={isActive}
      onClick={() =>
        isActive
          ? null
          : this.props.history.push(
              `/to-checker-order/${Base64func(
                this.state.currTOID,
                "encode"
              )}/${Base64func(boxNumber, "encode")}`
            )
      }
    >
      <div>
        Box # <span>{boxNumber}</span>
      </div>

      {isActive ? <MdCheckCircle /> : <FiChevronRight />}
    </TOActiveBox>
  );

  render() {
    let { boxData, serviceLoading } = this.state;
    return (
      <>
        {serviceLoading ? <TMLoader /> : null}

        {boxData?.filter((k) => !k.checked)?.length > 0 ? (
          <>
            <TitleWrapper title={"Scan Box to continue"} />

            <button
              className="bbtn"
              onClick={() => this.setState({ showScannerScreen: true })}
            >
              <AiOutlineScan /> Scan the barcode
            </button>
          </>
        ) : null}

        {this.state.showScannerScreen && (
          <BarcodeScanner
            scan={this.state.showScannerScreen}
            camera={this.state.showScannerScreen}
            redirect={"to-checker-box-process"}
            orderId={this.state.currTOID}
            history={this.props.history}
            getBoxId={this.updateBoxId}
            boxData={boxData}
          />
        )}

        {boxData?.filter((k) => !k.checked)?.length > 0 ? (
          <Divider>Or</Divider>
        ) : null}

        {boxData?.filter((k) => !k.checked)?.length > 0 ? (
          <TitleWrapper title={"Choose Boxes to continue"} />
        ) : null}

        <TOBoxWrapper>
          {boxData?.length > 0 ? (
            boxData?.filter((k) => !k.checked)?.length > 0 ? (
              boxData?.map((k, p) =>
                this.activeBoxSection(k.checked, k.boxNumber, p)
              )
            ) : (
              <>
                <NoBoxResult
                  success
                  icon={<DropboxOutlined />}
                  title="Congrats!"
                  subTitle="All boxes verified successfully"
                />
                <Divider />
                <PrintInvoice
                  access_token={this.props.access_token}
                  toId={this.state.currTOID}
                />
              </>
            )
          ) : (
            <NoBoxResult icon={<DropboxOutlined />} title="No boxes found!" />
          )}
        </TOBoxWrapper>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
});

const mapDispatchToProps = {
  getCheckerTOBoxesThunk,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TOCOBoxProcess)
);
